import { useState } from 'react';

import { missingEvidenceNote } from '../lib/evidence-view.ts';
import './evidence-image.css';

/**
 * One evidence image from GET /api/artifacts/:id/file, or a short note in its place.
 *
 * The file is asked for even when the row is marked expired: retention removes it a day after
 * the mark, and until then it is still there to show. Only a failed load swaps in the note,
 * which names the retention policy when that is why the file is gone.
 */
export function EvidenceImage({
  artifactId,
  alt,
  expiredAt = null,
  lazy = false,
}: {
  artifactId: number;
  alt: string;
  expiredAt?: number | null;
  lazy?: boolean;
}) {
  // Keyed by artifact, so a viewer that steps through screenshots tries each one afresh.
  const [failed, setFailed] = useState<number | null>(null);
  if (failed === artifactId) {
    return <span className="evidence-image-missing">{missingEvidenceNote(expiredAt)}</span>;
  }
  return (
    <img
      src={`/api/artifacts/${artifactId}/file`}
      alt={alt}
      {...(lazy ? { loading: 'lazy' as const } : {})}
      onError={() => setFailed(artifactId)}
    />
  );
}
